import { FormsModule } from '@angular/forms';
import { Component, OnDestroy, OnInit, Input, EventEmitter, Output, signal, WritableSignal } from '@angular/core';
import { ClientInformation } from 'src/app/models/client-information';
import { IntegrationInformation } from 'src/app/models/integration-information';
import { DestinationEndpoint } from 'src/app/models/destination-endpoint';
import { User } from '../../../../../models/user';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { ClientIntegrationService } from 'src/app/services/client-integration.service';
import { Integration } from 'src/app/models/integration';
import { ToastService } from 'src/app/services/toast.service';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { CommonModule } from '@angular/common';
import { ClientDropdownViewComponent } from '../client-dropdown-view/client-dropdown-view.component';
import { IntegrationDropdownViewComponent } from '../integration-dropdown-view/integration-dropdown-view.component';
import { IdentifierDropdownViewComponent } from '../identifier-dropdown-view/identifier-dropdown-view.component';
import { DestinationsDropdownViewComponent } from '../destinations-dropdown-view/destinations-dropdown-view.component';
@Component({
  selector: 'app-client-selection-view',
  imports: [
    FormsModule,
    MatButtonToggleModule,
    CommonModule,
    ClientDropdownViewComponent,
    IntegrationDropdownViewComponent,
    IdentifierDropdownViewComponent,
    DestinationsDropdownViewComponent,
  ],
  templateUrl: './client-selection-view.component.html',
  styleUrl: './client-selection-view.component.scss',
})
export class ClientSelectionViewComponent implements OnInit, OnDestroy {
  destroyed$: Subject<boolean> = new Subject();
  @Input() integrationInfoItems: IntegrationInformation[] | null = null;
  @Input() clients: ClientInformation[] | null = null;
  @Input() allowedDestinations: string[] | null = null;
  @Input() showLTClientSelectOption = false;
  @Input() onlyDataSwap = false;
  @Input() onlyFastFetch = false;
  @Input() onlyUseInfo = false;
  @Input() selectIdentifierForClients = true;

  @Output() clearAll = new EventEmitter<any>();
  @Output() itemSelected = new EventEmitter<any>();
  @Output() destSelected = new EventEmitter<any>();
  @Output() infoSelected = new EventEmitter<any>();
  @Output() integrationSelected = new EventEmitter<any>();
  @Output() informationSelected = new EventEmitter<any>();
  @Output() loadingFailed = new EventEmitter<any>();

  @Input() clientInformationId: string = null;
  @Input() destinationName: string = null;
  @Input() identifierId: string = null;
  @Input() identifierName: string = null;

  selectByLTClient = false;
  selectedClient: ClientInformation = null;
  selectedInfo: WritableSignal<IntegrationInformation | null> = signal<IntegrationInformation | null>(null);
  selectedIntegration: WritableSignal<Integration | null> = signal<Integration | null>(null);

  selectedDestination: WritableSignal<DestinationEndpoint | null> = signal<DestinationEndpoint | null>(null);
  destinationListOptions: WritableSignal<DestinationEndpoint[]> = signal<DestinationEndpoint[]>([]);
  allClients: WritableSignal<ClientInformation[]> = signal<ClientInformation[]>([]);

  destinationStrs: WritableSignal<string[]> = signal<string[]>([]);
  overrideDestinationName: WritableSignal<string> = signal<string>(null);

  failedLoading = false;

  constructor(
    private router: Router,
    private user: User,
    private toastService: ToastService,
    private readonly clientService: ClientIntegrationService)
  {  }

  ngOnInit(): void {
    if (this.destinationName != null && this.destinationName != undefined)
    {
      this.addToDestinationStrs(this.destinationName);
      this.overrideDestinationName.set(this.destinationName);
    }

    if (this.allowedDestinations != null && this.allowedDestinations.length > 0)
    {
      const dests = this.allowedDestinations;
      for(let i = 0; i < dests.length; i++)
      {
        if (dests[i] == 'CS' || dests[i] == 'CompenSafe' || dests[i] == 'IC')
        {
          if (!this.destinationStrs().includes('CSDataSwap'))
          {
            this.destinationStrs().push('CSDataSwap');
          }
        }
        else if (dests[i] == 'LG' || dests[i] == 'LimeGear' || dests[i] == 'NV' || dests[i] == 'MA')
        {
          if (!this.destinationStrs().includes('LGDataSwap'))
          {
            this.destinationStrs().push('LGDataSwap');
          }
        }
        else if (!this.destinationStrs().includes(dests[i]))
        {
          this.destinationStrs().push(dests[i]);
        }
      }
    }

    if (this.clients != null && this.clients.length > 0)
    {
      this.allClients.set(this.clients);
      if (this.allowedDestinations === null || this.allowedDestinations.length === 0)
      {
        this.allowedDestinations = ['CSDataSwap', 'LGDataSwap'];
        this.addToDestinationStrs('CSDataSwap');
        this.addToDestinationStrs('LGDataSwap');
      }
    }
    else if (this.integrationInfoItems != null && this.integrationInfoItems.length > 0)
    {
      this.allClients.set(
        this.integrationInfoItems.map((x) => new ClientInformation({
          losTalkerClientId: x.clientId,
          clientDisplayName: x.clientName,
          clientAbbreviatedName: '',
          compensafeInternalName: '',
          dataSourceTypeAgg: '',
          clientInformationId: x.clientInformationId,
        })),
      );

      if (this.allowedDestinations === null || this.allowedDestinations.length === 0)
      {
        const tmpDests = this.integrationInfoItems.map((x) => x.destinationName);
        if (tmpDests != null && tmpDests.length > 0)
        {
          this.allowedDestinations = tmpDests.filter((v, i, a) =>
            a.findIndex(t => t === v) === i,
          );
        }
      }
    }
    else if (this.selectByLTClient) {
      this.clientService.getAllClients()
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
          next: (data) => {
            if (data == null || data.length === 0)
            {
              this.loadingFailed.emit();
            }
            else {
              this.allClients.set(data);
            }
          },
          error: (_e) => {
            this.loadingFailed.emit();
            this.toastService.toastCreate('Failed to load clients.', 'Danger', {
              autoClose: false, 
            });
          },
      });

      if (this.allowedDestinations === null || this.allowedDestinations.length === 0)
      {
        this.allowedDestinations = ['CSDataSwap', 'LGDataSwap'];
        this.addToDestinationStrs('CSDataSwap');
        this.addToDestinationStrs('LGDataSwap');
      }
    }
  }

  addToDestinationStrs(value: string): void {
    if (this.destinationStrs() != null && this.destinationStrs() != undefined)
    {
      if (this.destinationStrs().includes(value) == false)
      {
        this.destinationStrs().push(value);
      }
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  changeSelectionMethod(): void {
    this.clearVars();
    this.clearAll.emit(null);
  }

  clearVars(): void {
    this.selectedDestination.set(null);
    this.selectedClient = null;
    this.selectedInfo.set(null);
    this.selectedIntegration.set(null);
  }

  getClientFromView(event: ClientInformation): void {
    if (event == null || event == undefined) {
      this.clearVars();
      this.itemSelected.emit(null);
    }
    else {
      this.selectedClient = event;
      this.itemSelected.emit(this.selectedClient);
    }
  }

  getIdentifierFromView(event: any): void {
    this.selectedInfo.set(event);
    this.informationSelected.emit(this.selectedInfo());
  }

  getIntegrationFromView(event: any): void {
    if (event == null || event == '') {
      this.selectedInfo.set(null);
      this.selectedIntegration.set(null);
    }
    else {
      this.selectedIntegration.set(event);
      this.integrationSelected.emit(this.selectedIntegration());
    }
  }

  getDestinationFromView(event: any): void {
    if (event == null || event == '') {
      this.clearVars();
      this.destSelected.emit(null);
    }
    else {
      this.selectedDestination.set(event);
      this.destSelected.emit(this.selectedDestination());
    }
  }

  setFailedLoading(event: any): void {
    if (event == true) {
      this.failedLoading = true;
      this.loadingFailed.emit(event);
    }
  }
}
